import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import LearningPathForm from './LearningPathForm/LearningPathForm.jsx';

import { postLearningPath } from '../../models/learning_path.js';

function LearningPathCreate() {
  const navigate = useNavigate();
  const { id: courseId } = useParams();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async payload => {
    setSubmitting(true);
    const response = await postLearningPath(courseId, payload);
    setSubmitting(false);
    if (response.status === 201) {
      alert('Ruta de aprendizaje creada con éxito.');
      navigate(`/courses/${courseId}/learning-paths`);
    } else {
      const message =
        response?.response?.data?.message ||
        response?.response?.data ||
        'No se pudo crear la ruta de aprendizaje.';
      alert(message);
    }
  };
  return <LearningPathForm submitting={submitting} onSubmit={handleSubmit} />;
}

export default LearningPathCreate;
